import { useTranslation } from "react-i18next";
import { LICENSE_SOURCE_META, LICENSE_STATUS_META, type StatusMeta } from "@/lib/license";

// 许可证状态 / 版本 / 来源的文案翻译：样式与图标仍来自 lib/license，
// 仅把展示文案接入 i18n，保证客户侧整页在英文模式下不再残留中文。
export function useLicenseLabels() {
  const { t } = useTranslation();

  const edition = (key: string | null | undefined) => (key ? t(`edition.${key}`, { defaultValue: key }) : "--");

  const statusMeta = (key: string): StatusMeta => {
    const base = LICENSE_STATUS_META[key];
    return {
      label: base ? t(`licenseStatus.${key}`, { defaultValue: base.label }) : key,
      className: base?.className ?? "bg-background-200 text-foreground-700",
    };
  };

  const sourceMeta = (key: string | null | undefined) => {
    const metaKey = key && LICENSE_SOURCE_META[key] ? key : "application";
    const base = LICENSE_SOURCE_META[metaKey];
    return {
      label: t(`licenseSource.${metaKey}`, { defaultValue: base.label }),
      className: base.className,
      icon: base.icon,
    };
  };

  return { edition, statusMeta, sourceMeta };
}